import { render, staticRenderFns } from "./XhTextarea.vue?vue&type=template&id=492c9204&scoped=true"
import script from "./XhTextarea.vue?vue&type=script&lang=js"
export * from "./XhTextarea.vue?vue&type=script&lang=js"
import style0 from "./XhTextarea.vue?vue&type=style&index=0&id=492c9204&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c9204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492c9204')) {
      api.createRecord('492c9204', component.options)
    } else {
      api.reload('492c9204', component.options)
    }
    module.hot.accept("./XhTextarea.vue?vue&type=template&id=492c9204&scoped=true", function () {
      api.rerender('492c9204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhTextarea.vue"
export default component.exports